import { render } from "./MyBreadcrumb.vue?vue&type=template&id=71706043&scoped=true"
import script from "./MyBreadcrumb.vue?vue&type=script&lang=js"
export * from "./MyBreadcrumb.vue?vue&type=script&lang=js"

import "./MyBreadcrumb.vue?vue&type=style&index=0&id=71706043&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71706043"]])

export default __exports__